// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36f9c2bf","952":"9e6e48dd"}[chunkId] + ".chunk.js";
};